const BaseSpam2Icon = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <path d="M7.968 1.25L10.75 4.0335V7.9685L7.968 10.75H4.033L1.25 7.968V4.033L4.033 1.25H7.968ZM7.5535 2.25H4.447L2.2505 4.4475V7.554L4.447 9.751H7.5535L9.7505 7.554V4.447L7.5535 2.25ZM5.5 7.5H6.5V8.5H5.5V7.5ZM5.5 3.5H6.5V6.5H5.5V3.5Z" />
  </svg>
);
  
export default BaseSpam2Icon;
  